import Constants from "app/lib/Constants";
import { ProviderNames } from "app/lib/data/models/Providers";
import { getAccountProvider } from "app/lib/utils/adaya/AdayaUtils";
import LocalStorage from "app/lib/utils/LocalStorage";
import { getLogger } from "app/lib/utils/logging";
import ApiService from "../ApiService";
import AuthService from "../AuthService";

const { log, warn } = getLogger('GoogleService', { color: 'green', enabled: false });

class GoogleService {

    // Prompts for Google login
    public login = async (user?) => {
        user = user || AuthService.getCurrentUser();
        log('login', user);

        return new Promise((resolve, reject) => {

            const loginCallbackSuccess = async (r) => {
                try {
                    log('login callback', r, user);
                    // update the token again if they happened to relogin to google somehow (maybe this is redundant?)
                    if (user) {
                        log("Trying to update google token...", user);
                        if (await this.tryUpdateToken(r, user)) {
                            log('Token updated, reloading user...');

                            // reload the changed user
                            let authed = await AuthService.checkSession();
                            if (authed) {
                                await AuthService.updateCurrentUser(user);
                                return resolve(true);
                            }
                            // some unknown error...
                            return resolve(false);
                        } else {
                            // not original user?
                        }
                    }

                    // login is ok anyway
                    return resolve(true);
                } catch (e) {
                    return reject(e);
                }
            };

            const loginCallbackMock = async (r) => {
                try {
                    let token = await this.getGoogleAccessToken();
                    log('FB.login failed... but using mock access token:', token);
                    r.authResponse = { accessToken: token };
                    return resolve(true);
                } catch (e) {
                    return reject(e);
                }
            };

            log('trying to login...');

            // todo:

            window.location.href = `${process.env.CLIENT_URL}/googleads-authorize`;
        });
    };

    // Gets current Google user's login status
    public checkLogin = async (user, updateToken = true) => {
        log(`checkLogin`)
        return new Promise((resolve, reject) => {
            return resolve(false);

            // todo...

            // // check actual user's status, and update token anyway...
            // FB.getLoginStatus(async (r) => {

            //     if (!r?.authResponse) {
            //         log('Cant validate user, no fb auth info?', r);
            //         // couldn't validate user, so trigger login again:
            //         return resolve(false);
            //     }

            //     log("Trying to update fb token...");

            //     // we have a user, try to update the token (it will check if it's original account user):

            //     if (updateToken) {
            //         if (user) {
            //             log("Trying to update fb token...", user);
            //             debug(user, "Trying to update Google token for: " + user.email, { fbResponse: r });

            //             if (await this.tryUpdateToken(r, user)) {
            //                 log('Token updated, done checkLogin...');
            //                 return resolve(true);
            //             } else {
            //                 log('Could not update token (not original user). Trying to check token from account...');
            //             }
            //         }
            //     }

            //     // check if it's a mock:
            //     if (this.useMockAccessToken()) {
            //         log('Mocking Google user...');
            //         // assume "logged in" if mocked
            //         if (await this.getGoogleAccessToken()) {
            //             return resolve(true);
            //         } else {
            //             log('NO MOCK TOKEN EXISTS, cannot mock.')
            //             // let it try to resolve to account token below.
            //         }
            //     }

            //     // otherwise just check the status:
            //     if (r.authResponse.status == 'connected') {
            //         // try to set an existing token for the account:
            //         if (user) {
            //             // try to use the existing token for the active account (if not original user);
            //             const fbProvider = getAccountProvider(user.activeAccount, ProviderNames.FACEBOOK);
            //             if (fbProvider?.oauth?.token) {
            //                 log('setting existing fb token for active account.', fbProvider.oauth.token);
            //                 debug(user, "Not original account user, but using account google token.", { fbResponse: r, fbAccessToken: fbProvider.oauth.token });
            //                 this.setGoogleAccessToken(fbProvider.oauth.token);
            //             }
            //         } else {
            //             // user connected but not logged in? use their info anyway...
            //             this.setGoogleAccessToken(r.authResponse.accessToken);
            //             console.log(`Set FB token current users.`);
            //             return resolve(true);
            //         }
            //     }

            //     debug(user, "Could not authenticate the user, user must login.", { fbResponse: r });
            //     return resolve(false);
            // });
        });
    };

    // does a checkLogin and a login if not connected.
    public assertLogin = async (user) => {
        return new Promise(async (resolve, reject) => {
            try {
                let connected = await this.checkLogin(user);
                if (!connected) {
                    if (this.hasMockAccessToken()) {
                        connected = true;
                    } else {
                        connected = await this.login(user);
                    }
                }

                if (!connected) {
                    return resolve(false);
                }

                return resolve(true);
            } catch (e) {
                console.log('FB assertlogin error', e);
                return resolve(false);
            }
        });
    };

    public hasMockAccessToken = () => {
        const tokenOverrides = LocalStorage.get(Constants.TOKEN_OVERRIDES);
        if (tokenOverrides && tokenOverrides[ProviderNames.GOOGLE]) {
            return tokenOverrides[ProviderNames.GOOGLE] != undefined;
        }
        return false;
    };

    public logout = async () => {
        return new Promise(async (resolve, reject) => {
            try {
                log('logout');
                // const apiAccessToken = await this.getGoogleAccessToken();
                // if (apiAccessToken) {
                LocalStorage.remove(Constants.GOOGLE_ACCESS_TOKEN);
                LocalStorage.remove(Constants.TOKEN_OVERRIDES); //  todo: make token removal per provider
                LocalStorage.remove(Constants.USE_MOCK_KEYS);
                let status = await this.getLoginStatus();
                if (status.status == 'connected') {
                } else {
                    return resolve(true);
                }
            } catch(e) {
                return reject(e);
            }
        });
    };

    // TODO: some of this below needs to be re-implemented for Google, but it's close...

    public getProfile = async (userId) => {
        return new Promise((resolve, reject) => {
            // todo: query google
            return resolve({ id: '1', email: 'rw3iss@gmail.com', name: 'Ryan Weiss' });
        });
    };

    // exchanges the given access token to get a long-lived token.
    public getAndSaveLongToken = async (token, accountUserId?) => {
        try {
            // todo: make a new route... maybe we will combine these, ie:  POST /users/providers/google/update-token or something... (but we want to probably move these endpoints to /account module)
            const tr: any = await ApiService.post('/auth/get-google-long-token', { token, accountUserId });

            if (tr.token) {
                this.setGoogleAccessToken(tr.token);
                return tr.token;
            } else {
                // just set the current short token for now, but should fix this...
                console.log('Couldnt generate long token, keeping short token.');
                this.setGoogleAccessToken(token);
                return token;
            }
        } catch (e) {
            log('long token error', e);
            throw e;
        }
    };

    public getAuthUrl = async () => {
        return await ApiService.get(`${process.env.API_URL}/googleads-auth-url`);
    };

    /**
     * @description Requests the given Google user be connected to the account.
     * @param {*} data
     */
    public connectGoogleAccount = async (data) => {
        return await ApiService.post(`${process.env.API_URL}/users/provider/google`, {
            email: data.email,
            access_token: data.access_token,
            refresh_token: data.refresh_token,
            googleEmail: data.googleEmail,
            customer: data.customer,
            login_customer_id: data.login_customer_id
        });
    };

    // Todo: finish
    public tryUpdateToken = async (r, user) => {
        let update = false;
        console.log(`tryUpdateToken`)

        if (await this.isOriginalUser(r.authResponse, user)) {
            log('IS ORIGINAL USER, updating token.');
            if (r.status === 'connected') {
                update = true;
            }
        }

        if (update) {
            // log("Updating long token...");
            // debug(user, "Updating Google token.", { fbAccessToken: r.authResponse.accessToken });
            // const tr = await this.getAndSaveLongToken(r.authResponse.accessToken, r.authResponse.userID);
            // log('Saved long token...');
            // if (tr) {
            //     // get a new user object if the original user was set on the account
            //     let authed = await AuthService.checkSession() !== false;
            //     if (authed) await AuthService.updateCurrentUser(user);
            //     return true;
            // }
        } else {
            log('cant update FB token because its a mock user and we cant find the FB profile.');
        }

        return false;
    };

    // Todo: finish
    public isOriginalUser = async (status, user) => {
        try {
            log('isOriginalUser?', status, user);

            // if no user is given, we assume original (ie. for signup page, etc):
            user = user || AuthService.getCurrentUser();
            if (!user) {
                return true;
            }

            let provider = getAccountProvider(user.activeAccount, ProviderNames.GOOGLE);

            if (provider && status) {
                // TODO:.........................
                if (provider.oauth?.accountUserId) {
                    // if account user id matches current, it's original user.
                    if (provider.oauth.accountUserId == status.userID) {
                        return true;
                    }
                }

                return false;
            }
        } catch (e) {
            console.log('Google isOriginalUser error', e);
        }
        return false;
    };


}

export default new GoogleService();